<template>
  <div
    class="v-preview-modal image-modal-wrapper generic-modal align-items-center justify-content-center position-fixed"
  >
    <div
      class="modal-inner align-items-center justify-content-center d-flex h-100 w-100"
      @mouseover="handleMouseOver"
      @mouseout="handleMouseOut">
      <div class="position-absolute me-15 mt-5 buttons-container">
        <button
          :class="isDownloading ? 'disable-btn':''"
          class="btn-primary bm-primary-btn me-15"
          href="#"
          style="color: white; right: 0; z-index: 9; top: 0"
          @click.self="downloadVideo"
        >
          <i
            v-show="isDownloading"
            class="fa fa-refresh fa-spin me-5" />Submit
          <ul
            v-if="downloadDD"
            :class="{ 'd-block': downloadDD }"
            class="drop-down-list position-absolute save-menu download-menu d-flex flex-column end-0"
          >
            <div class="download-title">Submit</div>
            <div class="download-title">File Types</div>
            <div class="d-flex flex-column gap-5">
              <div
                :class="fileType == 'mp4'? 'active-btn': ''"
                class="d-flex flex-row gap-10 row-box"
                @click.stop="selectType('mp4')">
                <div class="d-flex justify-content-center align-items-center">
                  <img src="../../assets/images/play.png">
                </div>
                <div class="d-flex flex-column">
                  <div class="mp4-title">MP4 Video</div>
                  <div class="video-quality">Standard 1080p (HD)</div>
                </div>
              </div>
              <!--              <div
                  :class="fileType == 'gif'? 'active-btn': ''"
                  class="d-flex flex-row gap-10 row-box"
                  @click.stop="selectType('gif')">
                <div class="d-flex justify-content-center align-items-center">
                  <img src="../../assets/images/gif-icon.png">
                </div>
                <div class="d-flex flex-column">
                  <div class="mp4-title">GIF</div>
                  <div class="video-quality">Standard 480p</div>
                </div>
              </div>-->
              <div
                :class="isDownloading ? 'disable-btn':''"
                class="d-flex justify-content-center align-items-center download-btn btn-primary bm-primary-btn"
                @click.stop="downloadVideo">
                <i
                  v-show="isDownloading"
                  class="fa fa-refresh fa-spin me-5" />Submit</div>
            </div>
          </ul>
        </button>
        <button
          class="bg-light text-dark bm-primary-btn"
          @click="closePreviewModal"
        >
          Close
        </button>
      </div>
      <div
        :style="getParentDivStyle"
        class="bm-modal-content preview-body">
        <div
          :style="`width:${videoWidth}px !important; height:${videoHeight}px;`"
          style="overflow:hidden; height: 100%;"
          class="video-container position-relative" >
          <div
            v-for="(page, index) in pages"
            :starttime="page.animation.startTime"
            :duration="page.animation.duration"
            :key="index"
            :class="'page-' + index"
            class="page"
            style="height: 100%;"
            @click.stop=""
          >
            <div
              :style="calculateDimensions(page)"
              class="overflow-hidden svg-img-shapes">
              <div
                :id="'main_page_div' + index"
                :style="getHTMLStyle(page)"
                class="canvas-wrapper overflow-hidden d-block position-absolute"
              >
                <component
                  v-for="(object, index) in page.objectList"
                  v-if="object.type !== 'pagedetails'"
                  :data="object"
                  :data-pageindex="object.PageIndex"
                  :element-index="index"
                  :is="object.type + '-object'"
                  :is-fake-rendering="false"
                  :key="object.Id"
                  :object-props="object"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="isVideoEnded ? 'show-player': ''"
        class="play-pause-container"
        @click.self="playPauseVideo()">
        <div
          :style="{ opacity: barAreaOpacity }"
          class="bar-area d-flex justify-content-center align-items-center"
          @mouseover="handleMouseOver"
          @mouseout="handleMouseOut">
          <div class="video-play-pause">
            <div
              v-show="!isPlaying && !isVideoEnded"
              @click="playPauseVideo()">
              <div v-html="playRounded" />
            </div>
            <div
              v-show="isPlaying && !isVideoEnded"
              @click="sceneO.pause()">
              <div v-html="pauseRounded" />
            </div>
            <div
              v-show="isVideoEnded && !isPlaying"
              @click="playPauseVideo()">
              <div v-html="replayRounded" />
            </div>
          </div>
          <div
            v-show="!isPlaying"
            @click="playPauseVideo()">
            <icon
              class="me-5 pe-5"
              name="play"
              role="button" />
          </div>
          <div
            v-show="isPlaying"
            @click="sceneO.pause()">
            <icon
              class="me-5 pe-5"
              name="pause-w"
              role="button" />
          </div>
          <input
            v-model="played"
            class="range__input preview"
            max="100"
            min="0"
            step="0.0001"
            type="range"
            @click="sceneO.pause()"
            @mousedown="sceneO.pause()"
            @input="setTime()"
          >
          <div class="text-light text-nowrap">
            {{ nanosecondsToTimeFormat() }} /
            {{ getTotalDurationInFormat }}
          </div>
          <!-- <span @click="toggleFullScreen" class="ms-5 ps-5" role="button">
        <icon name="expand-screen" />
      </span> -->
        </div>
      </div>
    </div>
    <div
      class="backdrop position-fixed h-100 w-100 dark"
      @click="closePreviewModal"
    />
    <audio
      v-if="product && product.audioDetails && product.audioDetails.audioUrl"
      ref="previewaudio"
      class="preview-audio">
      <source
        :src="product.audioDetails ? product.audioDetails.audioUrl : ''"
        type="audio/mp3">
    </audio>
  </div>
</template>

<script>
import {
  Text, Image as ImageObj, Path, Video,
} from '@/components/CanvasShapes';
import Scene from 'scenejs';
import MediaScene from '@scenejs/media';
import EventBus from '@/EventBus';
import _ from 'lodash';
import ApplicationEventTypes from '../../mixins/ApplicationEventTypes';
import {
  panleft,
  panright,
  typewriter,
  burst,
  pantop,
  panbottom,
  zoomin,
  zoomout,
  stomp,
  fade,
  photoZomEnterIn,
  photoZomEnterOut,
  photoRiseTop,
  photoRiseBottom,
  photoRiseLeft,
  photoRiseRight,
  transitionFade,
  transitionPanLeft,
  transitionPanRight,
  transitionPanTop,
  transitionPanBottom,
  transitionNone,
  singlePageDisplay,
  lastPageDisplay,
} from '../../library/Animations';


export default {
  name:       'PreviewModal',
  components: {
    'text-object':  Text,
    'shape-object': Path,
    'image-object': ImageObj,
    'video-object': Video,
  },
  props: {
    product:       null,
    isGrayScaleOn: Boolean,
  },
  data() {
    return {
      barAreaOpacity:     0,
      screenWidth:        0,
      screenHeight:       0,
      playRounded:        require('../../assets/icons/playRounded.svg'),
      pauseRounded:       require('../../assets/icons/pauseRounded.svg'),
      replayRounded:      require('../../assets/icons/replayRounded.svg'),
      sceneO:             null,
      page:               null,
      played:             0.0,
      isPlaying:          false,
      isVideoEnded:       false,
      isFullscreen:       false,
      isDownloading:      false,
      downloadDD:         false,
      pageVideoTimeoutes: [],
      fileType:           'mp4',
      audioLoop:          [],
      allAudioScenes:     [],
      modules:            {
        typewriter,
        burst,
        panleft,
        panright,
        pantop,
        panbottom,
        zoomin,
        zoomout,
        stomp,
        fade,
        photoZomEnterIn,
        photoZomEnterOut,
        photoRiseTop,
        photoRiseBottom,
        photoRiseLeft,
        photoRiseRight,
        transitionFade,
        transitionPanLeft,
        transitionPanRight,
        transitionPanTop,
        transitionPanBottom,
        transitionNone,
        singlePageDisplay,
        lastPageDisplay,
      },
    };
  },

  computed: {
    getParentDivStyle() {
      let pageHeight    = this.screenHeight;
      let pageWidth     = this.screenWidth;
      const aspectRatio = this.videoWidth / this.videoHeight;
      if (parseInt(this.videoWidth) < parseInt(this.videoHeight)) {
        pageWidth = pageHeight * aspectRatio;
      } else if (parseInt(this.videoWidth) > parseInt(this.videoHeight)) {
        pageWidth  = this.screenHeight;
        pageHeight = pageWidth / aspectRatio;
      } else {
        pageHeight = this.screenHeight;
        pageWidth  = this.screenHeight;
      }
      const scaleX = pageWidth / this.videoWidth;
      const scaleY = pageHeight / this.videoHeight;
      const style  = {
        transform: `scaleX(${scaleX}) scaleY(${scaleY})`,
        width:     `${this.videoWidth}px !important`,
        height:    `${this.videoHeight}px !important`,
        margin:    '0',
        overflow:  'visible',
        minWidth:  'auto !important',
      };
      return style;
    },
    getTotalDurationInFormat() {
      if (this.sceneO) {
        const totalSeconds     = this.sceneO.getTotalDuration();
        const minutes          = Math.floor(totalSeconds / 60);
        const seconds          = totalSeconds % 60;
        const formattedMinutes = (minutes < 10) ? `0${minutes}` : minutes;
        const formattedSeconds = (seconds < 10) ? `0${parseInt(seconds)}` : parseInt(seconds);
        return `${formattedMinutes}:${formattedSeconds}`;
      }
      return 0;
    },
    videoWidth() {
      return this.pages[0].width;
    },
    videoHeight() {
      return this.pages[0].height;
    },
    pages() {
      return this.product.pages;
    },
    isRenderer() {
      return this.$route.name == 'Renderer';
    },
    hasProductAudio() {
      return this.product && this.product.audioDetails && this.product.audioDetails.audioUrl;
    },
  },
  mounted() {
    this.screenWidth  = window.innerWidth;
    this.screenHeight = window.innerHeight;
    this.page         = _.cloneDeep(this.pages[0]);
    this.initiateAnimation();
    console.log(this.$store.getters.getIsLoaderVisible);
    if (this.$store.getters.getIsLoaderVisible) {
      console.log('this.$store.getters.getIsLoaderVisible');
      console.log(this.$store.getters.getIsLoaderVisible);
      this.fileType = 'mp4';
      this.downloadVideo();
    }
  },
  beforeDestroy() {
    for (let i = 0; i < this.pageVideoTimeoutes.length; i++) {
      clearTimeout(this.pageVideoTimeoutes[i]);
    }
  },
  methods: {
    getProductWidth(width) {
      return (parseInt(width / 2)) * 2;
    },
    getProductHeight(height) {
      return (parseInt(height / 2)) * 2;
    },
    handleMouseOver() {
      this.barAreaOpacity = 1;
    },
    handleMouseOut() {
      this.barAreaOpacity = 0;
    },
    nanosecondsToTimeFormat() {
      if (this.sceneO) {
        const totalSeconds     = this.sceneO.getTime();
        const minutes          = Math.floor(totalSeconds / 60);
        const seconds          = totalSeconds % 60;
        const formattedMinutes = (minutes < 10) ? `0${minutes}` : minutes;
        const formattedSeconds = (seconds < 10) ? `0${parseInt(seconds)}` : parseInt(seconds);
        return `${formattedMinutes}:${formattedSeconds}`;
      }
      return 0;
    },
    selectType(type) {
      console.log('Type ', type);
      this.fileType = type;
      console.log('FileType ', this.fileType);
    },
    getScale(page, pageWidth, pageHeight) {
      return `scale(${this.calculatedScale(page, pageWidth, pageHeight).x},${
        this.calculatedScale(page, pageWidth, pageHeight).y
      })`;
    },

    calculatedScale(page, pageWidth, pageHeight) {
      const scale = {
        x: pageWidth / page.width,
        y: pageHeight / page.height,
      };
      return scale;
    },

    getHTMLStyle(page) {
      const newStyle = {
        backgroundColor:  '#ffffff',
        backgroundImage:  `url(${this.baseImage})`,
        backgroundRepeat: 'no-repeat',
        filter:           this.isGrayScaleOn ? 'grayscale(1)' : 'grayscale(0)',
        width:            `${this.getProductWidth(page.width)}px`,
        height:           `${this.getProductHeight(page.height)}px`,
        transformOrigin:  'left top',
        overflow:         'hidden',
      };
      return newStyle;
    },

    calculateDimensions(page) {
      const style = {
        width:    `${page.width}px`,
        height:   `${page.height}px`,
        position: 'relative',
      };
      return style;
    },

    initiateAnimation() {
      const self  = this;
      let start   = 0.0;
      self.sceneO = new Scene();
      self.pages.forEach((page, i) => {
        page.animation.startTime = start;
        if (page.objectList.length) {
          page.objectList.forEach((object) => {
            const clonedObj = _.cloneDeep(object);
            if (object.animation && object.animation.style && object.animation.style !== '') {
              const { style } = object.animation;
              const animation = { ...object.animation };
              let selector    = `.v-preview-modal .page-${i} div[data-elementindex='${object.elementIndex}']`;
              if (style.includes('photo')) {
                selector += ' img';
              }
              animation.selector                     = selector;
              clonedObj.animation.selector           = selector;
              clonedObj.animation.startTime          = start;
              clonedObj.animation.duration           = page.animation.duration;
              clonedObj.animation.parentPageDuration = page.animation.duration;
              clonedObj.objectOpacity                = clonedObj.effects ? clonedObj.effects.transparency.value / 100 : 1;
              if (clonedObj.type === 'shape') { clonedObj.objectOpacity = clonedObj.Alpha / 100; }
              const sceneItem = this.modules[style](clonedObj);
              self.sceneO.setItem(selector, sceneItem);
            }
            if (object.type == 'video') {
              clonedObj.animation.parentPageDuration = page.animation.duration;
              if (clonedObj.videoDetails.audio) {
                const audioScene = self.getAudioScene(clonedObj, start, i);
                const identifier = `audio${clonedObj.Id}${i}`;
                self.sceneO.setItem(identifier, audioScene);
                self.allAudioScenes.push(identifier);
              }
              const videoScene = self.getVideoScene(clonedObj, start, i);
              self.sceneO.setItem(`video${clonedObj.Id}${i}`, videoScene);
            }
          });
        }
        start += parseFloat(page.animation.duration);
      });

      if (this.product.transitions && this.product.transitions.length > 0) {
        this.product.transitions.forEach((tr, i) => {
          const sceneT = this.modules[tr.name](tr, i);
          self.sceneO.setItem(`transition${i}`, sceneT);
          if (i + 1 == this.product.transitions.length) {
            const sceneEnd = this.modules.lastPageDisplay(tr, i);
            self.sceneO.setItem('page-last', sceneEnd);
          }
        });
      } else {
        const scene = this.modules.singlePageDisplay(this.product.pages[0].animation);
        self.sceneO.setItem('page-single', scene);
      }

      if (this.hasProductAudio) {
        console.log('this.product.audioDetails');
        console.log(this.product.audioDetails);
        this.audioLoop.push({
          url:             this.product.audioDetails.audioUrl,
          seekFrom:        this.product.audioDetails.startTime,
          seekTo:          this.product.audioDetails.endTime,
          delay:           0,
          iteration:       1,
          duration:        this.product.audioDetails.trimDuration,
          fadeInDuration:  this.product.audioDetails.fadeIn,
          fadeInStart:     0,
          fadeOutStart:    this.product.audioDetails.fadeOut - this.product.audioDetails.startTime,
          fadeOutDuration: this.product.audioDetails.endTime - this.product.audioDetails.fadeOut,
        });
      }

      self.sceneO.on('animate', (e) => {
        self.played = (100 * e.time) / self.sceneO.getTotalDuration();
        self.muteUnusedVideos();
        if (this.hasProductAudio) {
          self.fadeProductAudio();
        }
      });
      self.sceneO.on('paused', () => {
        self.isPlaying = false;
      });
      self.sceneO.on('play', () => {
        self.isPlaying = true;
        if (this.hasProductAudio) {
          this.syncProductAudio();
          this.$refs.previewaudio.play();
        }
      });
      self.sceneO.on('paused', () => {
        if (this.hasProductAudio) {
          this.$refs.previewaudio.pause();
        }
      });
      self.sceneO.on('ended', () => {
        self.resetVideo();
      });

      console.log(self.sceneO);
      if (!this.isRenderer) {
        self.checkVideosLoaded().then(() => {
          setTimeout(() => {
            EventBus.$emit('showHideLoader', false);
            self.sceneO.play();
          }, 1);
        }).catch((error) => {
          console.error('Error while checking for video loading:', error);
        });
      }
      window.scene = self.sceneO;
    },

    checkVideosLoaded() {
      return new Promise((resolve) => {
        const videos = Array.from(document.querySelectorAll('.v-preview-modal .page-0 video'));
        function checkAllVideosLoaded() {
          return videos.every(video => video.readyState >= 3);
        }
        function checkRepeatedly() {
          if (checkAllVideosLoaded()) {
            resolve('All videos have been loaded.');
          } else {
            setTimeout(checkRepeatedly, 100); // Check again after 100 milliseconds
          }
        }
        checkRepeatedly(); // Start the initial check
      });
    },

    syncProductAudio() {
      const { startTime }                 = this.product.audioDetails;
      this.$refs.previewaudio.currentTime = parseFloat(startTime + parseFloat(this.currentTime()));
    },

    fadeProductAudio() {
      console.log(this.product.audioDetails);
      const {
        startTime, endTime, fadeIn, fadeOut,
      } = this.product.audioDetails;
      console.log('startTime: ', startTime);
      console.log('endTime: ', endTime);
      console.log('fadeIn: ', fadeIn);
      console.log('fadeOut: ', fadeOut);

      if ((parseFloat(this.$refs.previewaudio.currentTime)) >= endTime) {
        this.$refs.previewaudio.volume = 0;
        console.log('(startTime + parseFloat(this.currentTime())) > endTime');
        return;
      }

      if ((parseFloat(this.$refs.previewaudio.currentTime)) < (fadeIn + startTime)) {
        const volume = this.calculatePercentage(
          parseFloat(startTime),
          parseFloat(fadeIn + startTime),
          parseFloat(this.$refs.previewaudio.currentTime),
        ) / 100;
        console.log(volume);
        this.$refs.previewaudio.volume = volume;
      } else if ((parseFloat(this.$refs.previewaudio.currentTime)) > (fadeOut)) {
        let volume = this.calculatePercentage(
          parseFloat(fadeOut),
          parseFloat(endTime),
          parseFloat(this.$refs.previewaudio.currentTime),
        ) / 100;
        console.log('currentTime: ', this.$refs.previewaudio.currentTime);
        console.log(volume);
        if (volume < 0) {
          // volume = 0;
        } else if (volume > 1) {
          volume = 1;
        } else {
          volume = 1 - volume;
          // volume = 1 % volume;
        }
        console.log('volume ', volume);
        this.$refs.previewaudio.volume = volume;
      } else {
        this.$refs.previewaudio.volume = 1;
      }
    },

    calculatePercentage(startRange, endRange, currentValue) {
      if (currentValue < startRange) {
        return 0;
      }
      if (currentValue > endRange) {
        return 100;
      }
      const range           = endRange - startRange;
      const normalizedValue = currentValue - startRange;
      const percentage      = (normalizedValue / range) * 100;
      return percentage;
    },

    muteUnusedVideos() {
      if (this.allAudioScenes.length) {
        this.allAudioScenes.forEach((audSceneName) => {
          const audScene    = this.sceneO.getItem(audSceneName);
          const currentTime = parseFloat(this.currentTime());
          if (currentTime > (parseFloat(audScene.endTime) + parseFloat(audScene.startTime))) {
            audScene.pause();
            this.sceneO.setItem(audSceneName, audScene);
          }
        });
      }
    },

    setTime() {
      console.log("Hello");
      this.sceneO.setTime(`${this.played}%`);
    },

    getAudioScene(object, startTime, pageIndex) {
      const mediaScene         = new MediaScene();
      let audioPlayingDuration = object.animation.parentPageDuration;
      if (object.videoDetails.endTime) {
        audioPlayingDuration = object.videoDetails.endTime - object.videoDetails.startTime;
        if (audioPlayingDuration > object.animation.parentPageDuration) {
          audioPlayingDuration =  object.animation.parentPageDuration;
        }
      }
      mediaScene
        .addMedia(object.videoDetails.audio)
        .seek(parseFloat(object.videoDetails.startTime), parseFloat(object.videoDetails.startTime) + parseFloat(audioPlayingDuration))
        .setVolume(1)
        .setPlaySpeed(1)
        .setDelay(startTime)
        .setIterationCount(object.animation.parentPageDuration / audioPlayingDuration);

      mediaScene.startTime = startTime;
      mediaScene.endTime   = object.animation.parentPageDuration;

      const seekFrom  = parseFloat(object.videoDetails.startTime);
      const seekTo    = seekFrom + parseFloat(audioPlayingDuration);
      const iteration = parseFloat(object.animation.parentPageDuration) / parseFloat(audioPlayingDuration);
      const duration  = (seekTo - seekFrom) * iteration;

      this.audioLoop.push({
        url:   object.videoDetails.audio,
        seekFrom,
        seekTo,
        delay: startTime,
        iteration,
        duration,
      });
      return mediaScene;
    },
    getVideoScene(object, startTime, pageIndex) {
      const video              = document.querySelector(`.v-preview-modal .page-${pageIndex} #video${object.Id}`);
      const mediaScene         = new MediaScene();
      let audioPlayingDuration = object.animation.parentPageDuration;
      if (object.videoDetails.endTime) {
        audioPlayingDuration = object.videoDetails.endTime - object.videoDetails.startTime;
        if (audioPlayingDuration > object.animation.parentPageDuration) {
          audioPlayingDuration =  object.animation.parentPageDuration;
        }
      }
      // let diff = 0.00;
      // if(object.videoDetails.startTime > 0.5) diff = 0.05;
      const st = parseFloat(object.videoDetails.startTime).toFixed(3);
      const et = parseFloat(parseFloat(object.videoDetails.startTime) + parseFloat(audioPlayingDuration).toFixed(3));
      // console.log(object.videoDetails.startTime + '0')
      // console.log(object.videoDetails.startTime + audioPlayingDuration + '0')
      mediaScene
        .addMedia(video)
        .seek(st, et)
        .setVolume(1)
        .setPlaySpeed(1)
        .setDelay(startTime)
        .setIterationCount(object.animation.parentPageDuration / audioPlayingDuration);
      console.log(mediaScene);
      return mediaScene;
    },

    scenePaused() {
      for (let i = 0; i < this.pageVideoTimeoutes.length; i++) {
        clearTimeout(this.pageVideoTimeoutes[i]);
      }
      document.querySelectorAll('.v-preview-modal video').forEach((video) => {
        video.pause();
      });
    },

    toggleFullScreen() { // not getting used at the moment
      if (document.fullscreenElement) {
        document.exitFullscreen();
        this.isFullscreen = false;
        return;
      }
      document.querySelector('.v-preview-modal').requestFullscreen();
      this.isFullscreen = true;
    },

    hasSomeParentTheClass(element, classname) {
      if (element.className && element.className.split(' ').indexOf(classname) >= 0) {
        return true;
      }
      return (
        element.parentNode && this.hasSomeParentTheClass(element.parentNode, classname)
      );
    },

    playVideo() {
      if (this.sceneO.getPlayState() == 'paused') {
        this.sceneO.play();
        return;
      }
      if (this.sceneO.isEnded()) {
        this.sceneO.setTime(0);
        this.sceneO.play();
      }
    },

    playPauseVideo() {
      if (this.sceneO.getPlayState() == 'paused') {
        this.sceneO.play();
        this.isVideoEnded = false;
        return;
      }
      if (this.sceneO.isEnded()) {
        this.isVideoEnded = false;
        this.sceneO.setTime(0);
        this.sceneO.play();
        return;
      }
      if (this.sceneO.getPlayState() !== 'paused') {
        this.sceneO.pause();
      }
    },

    async downloadVideo() {
      const type = this.fileType;
      if (this.isDownloading) {
        return;
      }
      if (type == '') {
        alert('Please Select File Type');
        return;
      }
      // resetting video to 0 for initial html/css
      this.sceneO.pause();
      this.sceneO.setTime(0);

      this.isDownloading = true;

      // compute data to be posted on node server
      const pagesHtml   = document.querySelector('.preview-body').innerHTML;
      const tempDiv     = document.createElement('div');
      tempDiv.innerHTML = pagesHtml;
      tempDiv.classList.add('tempdiv', 'd-none');
      document.querySelector('body').appendChild(tempDiv);
      const tempVideos = document.querySelectorAll('.tempdiv video');
      tempVideos.forEach((v) => {
        if (v.dataset.highres && v.dataset.highres !== '' && v.dataset.highres != 'undefined') {
          v.setAttribute('src', v.dataset.highres);
          v.innerHTML = `<source src="${v.dataset.highres}"></source>`;
        }
      });


      let html     = `
          <\!DOCTYPE html>
          <html lang="en">
          <head>
            <\script src="https://unpkg.com/@babel/standalone/babel.min.js"><\/script>
            <\script src="https://daybrush.com/scenejs/release/latest/dist/scene.js"><\/script>
            <\script src="https://daybrush.com/scenejs-effects/release/latest/dist/effects.js"><\/script>
            <\script src="https://daybrush.com/scenejs-media/release/latest/dist/media.js"><\/script>
            <\script src="https://dev2.wysiwyg.bankmarketingcenter.com/BMCVideo2/assets/AnimationFunctions.js?v=1"><\/script>
            <\script src="https://daybrush.com/codepen/scene.js"><\/script>
            <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css?v=1" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">
            <link type="text/css" rel="stylesheet" href="https://www.bankmarketingcenter.com/handlers/FontListHandler.ashx?version=1693298463580">
            <link href="https://dev2.wysiwyg.bankmarketingcenter.com/BMCVideo3/css/app.css?v=1" rel="stylesheet">
            <style>
                @import url(https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,600;0,700;1,300&display=swap);
            </style>
            <style>
                .bar-area{
                    display:none !important;
                }
                .svg-img-shapes{
                  transform: scale(1, 1) !important;
                }
                * {
                  text-rendering: geometricprecision !important;
                }
            </style>


          </head>
          <body>

            ${tempDiv.innerHTML}
                <script >

                    let start = 0.0;
                    let played = 0.0
                    let scene = new Scene();
                    let mediaScene = null;
                    let pageStyle = null;
                    let hasAnyVideo = false;
                    let pages = ${JSON.stringify(this.pages)}
                    let product = ${JSON.stringify(this.product)}
                    pages.forEach((page, i) => {
                    page.animation.startTime = start;
                    pageStyle                = page.animation.style;
                    // let sceneItem = eval(pageStyle+"(page, i, '.page-')");
                    // scene.setItem(".page-" + i, sceneItem);
                    // playVideosWithPreview(sceneItem, start);
                    if (page.objectList.length) {
                        page.objectList.forEach((object) => {
                          const clonedObj = {...object};
                        if (object.animation && object.animation.style && object.animation.style !== "") {
                            const style = object.animation.style;
                            let animation = { ...object.animation };
                            let selector = ".page-" + i + " div[data-elementindex='"+object.elementIndex+"']";
                            if (style.includes('photo')) {
                            selector = selector + " img";
                            }
                            // if (object.type == "image" && object.ImageType != "SVGImage") {
                            // selector = selector + " .anim";
                            // } else if (object.type == "text") {
                            // selector = selector + " .focus-text-div";
                            // } else if (object.type == "shape" || object.ImageType == "SVGImage") {
                            // selector = selector + " > div";
                            // } else if (object.type == "video") {
                            // selector = selector + " video";
                            // }
                            animation.selector = selector;
                            //const clonedObj = {...object};
                            clonedObj.animation.selector = selector;
                            clonedObj.animation.startTime = start;
                            console.log("animation start: ", start);
                            clonedObj.animation.duration = page.animation.duration;
                            clonedObj.animation.parentPageDuration = page.animation.duration;
                            clonedObj.objectOpacity = clonedObj.effects ? clonedObj.effects.transparency.value / 100 : 1;
                             if (clonedObj.type === 'shape') { clonedObj.objectOpacity = clonedObj.Alpha / 100; }
                            const sceneItem = window[style](clonedObj);
                            console.log(sceneItem);
                            scene.setItem(selector, sceneItem);
                        }
                        if (object.type == 'video' ) {
                          if(!hasAnyVideo){
                            mediaScene = new MediaScene(); // declare once only
                          }
                           clonedObj.animation.parentPageDuration = parseFloat(page.animation.duration);
                           const videoScene                       = getVideoScene(clonedObj, start, i);
                           console.log('clonedObj.videoDetails.audio: ', clonedObj.videoDetails.audio)
                           if(clonedObj.videoDetails.audio){
                            console.log('Creating Audio Scene')
                            const audioScene = getAudioScene(clonedObj, start, i);
                           }
                           hasAnyVideo                            = true;
                        }
                        });
                    }
                    start += parseFloat(page.animation.duration);
                    });
                    if(hasAnyVideo){
                      scene.setItem("media", mediaScene);
                    }

                    if (product.transitions && product.transitions.length) {
                      product.transitions.forEach((tr, i) => {
                        console.log(tr.name);
                        // const scene = this.modules[tr.name](tr, i);
                        const sceneT = window[tr.name](tr, i);

                        // const scene = transitionPan(tr, i);
                        scene.setItem('transition'+i, sceneT);
                        if (i + 1 == product.transitions.length) {
                          const sceneEnd = lastPageDisplay(tr, i);
                          scene.setItem('page-single', sceneEnd);
                        }
                      });
                    } else {
                      const sceneSingle = singlePageDisplay(product.pages[0].animation);
                      scene.setItem('page-single', sceneSingle);
                    }


                    scene.setPlaySpeed(1);
                    scene.setEasing("ease-in-out");
                   function getAudioScene(object, startTime, pageIndex) {
                        let audioPlayingDuration = object.animation.parentPageDuration;
                        if (object.videoDetails.endTime) {
                            audioPlayingDuration = object.videoDetails.endTime - object.videoDetails.startTime;
                            if (audioPlayingDuration > object.animation.parentPageDuration) {
                                audioPlayingDuration =  object.animation.parentPageDuration;
                            }
                        }
                        mediaScene
                            .addMedia('audio-'+object.Id+pageIndex, object.videoDetails.audio)
                            .seek(parseFloat(object.videoDetails.startTime), parseFloat(object.videoDetails.startTime) + parseFloat(audioPlayingDuration))
                            .setVolume(1)
                            .setPlaySpeed(1)
                            .setDelay(startTime)
                            .setIterationCount(object.animation.parentPageDuration / audioPlayingDuration);
                    }
                function    getVideoScene(object, startTime, pageIndex) {
                        const video              = document.querySelector('.page-' + pageIndex + ' #video'+object.Id);
                        console.log(video)
                        let audioPlayingDuration = object.animation.parentPageDuration;
                        if (object.videoDetails.endTime) {
                            audioPlayingDuration = object.videoDetails.endTime - object.videoDetails.startTime;
                            if (audioPlayingDuration > object.animation.parentPageDuration) {
                                audioPlayingDuration =  object.animation.parentPageDuration;
                            }
                        }
                        mediaScene
                            .addMedia('video-'+object.Id+pageIndex, video)
                            .seek(parseFloat(object.videoDetails.startTime), parseFloat(object.videoDetails.startTime) + parseFloat(audioPlayingDuration))
                            .setVolume(1)
                            .setPlaySpeed(1)
                            .setDelay(startTime)
                            .setIterationCount(object.animation.parentPageDuration / audioPlayingDuration);
                    }
                    //scene.play();
                <\/script>
          </body>
          </html>
          `;
      html         = html.replaceAll('scale(0.888)', 'scale(1, 1)'); // for firefox
      html         = html.replaceAll('scale(0.888, 0.888)', 'scale(1, 1)');
      html         = html.replaceAll('’', "'"); // this quote is causing problem in video capturing
      html         = html.replaceAll('–', '&#8211;');
      html         = html.replaceAll('•', '&bull;');
      const width  = parseInt(this.pages[0].width, 10);
      const height = parseInt(this.pages[0].height, 10);
      console.log(Math.max(width, height));
      const scale = 1;
      tempDiv.remove();
      // const scale = parseInt(1920 / Math.max(width, height));
      // width       = Math.ceil(scale * width);
      // height      = Math.ceil(scale * height);

      // create video/audio array
      const audioArray = [];
      let toatalTime   = 0.0;
      this.pages.forEach((page) => {
        page.objectList.forEach((object) => {
          if (object.type == 'video') {
            const startTime     = parseFloat(toatalTime);
            const clipStartTime = parseFloat(object.videoDetails.startTime);
            let endTime         = toatalTime + parseFloat(page.animation.duration);
            if (object.videoDetails.endTime) {
              const audioDuration = (parseFloat(object.videoDetails.endTime) - clipStartTime).toFixed(2);
              if ((parseFloat(toatalTime) + parseFloat(audioDuration)) <= (parseFloat(toatalTime) + parseFloat(page.animation.duration))) {
                endTime = parseFloat(toatalTime) + parseFloat(audioDuration);
              }
            }
            const audioUrl = object.videoDetails.VideoSourceUrl.replaceAll('.webm', '.mp3');
            const fadeIn   = '';
            const fadeOut  = '';
            const duration = parseFloat(endTime) - parseFloat(startTime);
            audioArray.push({
              startTime, clipStartTime, endTime, audioUrl, fadeIn, fadeOut, duration,
            });
          }
        });
        toatalTime += parseFloat(page.animation.duration);
      });


      // const url       = 'https://productdesigner.uforialogic.com/node/render';
      const url       = 'https://video-processing.bankmarketingcenter.com/node/render';
      const myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
      const urlencoded = new URLSearchParams();
      urlencoded.append('width', width);
      urlencoded.append('height', height);
      urlencoded.append('scale', scale);
      urlencoded.append('audio', JSON.stringify(this.audioLoop));
      urlencoded.append('bankURL', this.$store.getters.getBMCInstance);
      urlencoded.append('gif', 1);
      urlencoded.append('pdfHTML', html);
      const requestOptions  = {
        method:   'POST',
        headers:  myHeaders,
        body:     urlencoded,
        redirect: 'follow',
      };
      let videoUrl          = '';
      let videoWatermarkUrl = '';

      // fetch video file link
      await fetch(url, requestOptions)
        .then(response => response.text())
        .then((result) => {
          console.log(result);
          videoUrl          = JSON.parse(result).mp4 != '' ? JSON.parse(result).mp4 : JSON.parse(result).originalAudio;
          videoWatermarkUrl = JSON.parse(result).watermarkVideoUrl != '' ? JSON.parse(result).watermarkVideoUrl : JSON.parse(result).originalAudio;
          const videoGifUrl = videoUrl.replace('-final.mp4', '.gif');
          EventBus.$emit(ApplicationEventTypes.Video.UPDATE_VIDEO_URL_ATTR_IN_PRODUCT, videoUrl);
          EventBus.$emit(ApplicationEventTypes.Video.UPDATE_VIDEO_WATERMARK_URL_ATTR_IN_PRODUCT, videoWatermarkUrl);
          EventBus.$emit(ApplicationEventTypes.Video.UPDATE_VIDEO_GIF_URL_ATTR_IN_PRODUCT, videoGifUrl);
          this.$store.commit('setSaveApiMethod', 'NewEditorSubmit');
          this.$store.commit('setSubmittedAs', 'video');
          EventBus.$emit('saveProduct', '');
        })
        .catch(error => console.log('error', error));

      // code for downloading file
      const file  = new Blob([html], { type: 'text/plain' });
      const link  = document.createElement('a');
      const link2 = document.createElement('a');
      link2.href  = URL.createObjectURL(file);
      link.href   = videoUrl;
      link.setAttribute('download', '');
      link.setAttribute('target', '_blank');
      link.download  = 'video.mp4';
      link2.download = 'video.html';
      if (type == 'gif') {
        link.download = 'video.gif';
      }
      // link.click();
      // link2.click(); // will produce html file for testing
    },

    resetVideo() {
      this.isVideoEnded = true;
      this.sceneO.setTime(0);
    },

    currentTime() {
      return this.sceneO
        ? this.sceneO.getTime() < 10
          ? `0${this.sceneO.getTime().toFixed(1)}`
          : this.sceneO.getTime().toFixed(1)
        : '00.00';
    },
    currentPage() {
      const currentTime = this.currentTime();
      let currentPage   = '';
      this.pages.forEach((page, i) => {
        if (parseFloat(page.animation.startTime) <= parseFloat(currentTime)) {
          currentPage = `page-${i}`;
        }
      });
      return currentPage;
    },
    isPaused() {
      return this.sceneO ? this.sceneO.isPaused() : false;
    },
    setAllVideosTime(currentTime) {
      const videos = document.querySelectorAll('.v-preview-modal video');
      if (videos) {
        videos.forEach((video) => {
          const pageDiv            = video.closest('.page');
          const videoPageStartTime = parseFloat(pageDiv.getAttribute('starttime'));
          const videoPageDuration  = parseFloat(pageDiv.getAttribute('duration'));
          const videoStartTime     = parseFloat(video.getAttribute('starttime'));
          const videoEndTime       = video.getAttribute('endtime');
          const slidePlayedTime    = currentTime - parseFloat(videoPageStartTime);
          const videoCurrentTime   = slidePlayedTime + videoStartTime;
          console.log(videoPageDuration, videoPageStartTime, currentTime);
          if ((videoPageDuration + videoPageStartTime) < parseFloat(currentTime)) {
            video.pause();
          }
        });
      }
    },
    pauseVideosIfHiddenFromCurrentSlide(currentTime) {
      const videos = document.querySelectorAll('.v-preview-modal video');
      if (videos) {
        videos.forEach((video) => {
          const pageDiv            = video.closest('.page');
          const videoPageStartTime = parseFloat(pageDiv.getAttribute('starttime'));
          const videoPageDuration  = parseFloat(pageDiv.getAttribute('duration'));
          const videoStartTime     = parseFloat(video.getAttribute('starttime'));
          const videoEndTime       = video.getAttribute('endtime');
          const slidePlayedTime    = currentTime - parseFloat(videoPageStartTime);
          const videoCurrentTime   = slidePlayedTime + videoStartTime;
          console.log(videoPageDuration, videoPageStartTime, currentTime);
          if ((videoPageDuration + videoPageStartTime) < parseFloat(currentTime)) {
            video.pause();
          }
        });
      }
    },
    closePreviewModal() {
      this.sceneO.end();
      this.$store.commit('setDisplayPreviewModal', false);
    },
  },
};
</script>

<style lang="scss">
.bm-modal-content {
  width: auto !important;
  box-shadow: none;

  & > div {
    width: auto !important;
  }
  &.preview-body {
    overflow: hidden;
    left: 0;
    right: 0;
    margin:auto;
    min-width: auto;
  }
}

.bar-area {
  position: fixed;
  z-index: 99;
  //   width: 600px;
  justify-content: center;
  opacity: 1;
  transition: all ease-in-out 150ms;
  padding: 15px;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  left: 400px;
  right: 400px;
  cursor: initial;

  .video-play-pause {
    position: fixed;
    top: 50%;
    cursor: pointer;
    left: 50%;
    z-index: 9999;
    transform: translate(-50%, -50%);
    div {
      width: 60px;
      height: 60px;
      svg {
        width: 60px;
        height: 60px;
      }
    }
  }
}

.image-modal-wrapper {
  .backdrop.dark {
    background-color: rgba(0, 0, 0, 1);
    filter: none;
  }
}
.range__input.preview {
  width: calc(100% - (150px));
  margin-right: 15px;
  cursor: pointer;
}

.bm-modal-content.position-fixed .play-pause-container {
  position: absolute;
  width: 100% !important;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  opacity: 0;
  justify-content: center;
  align-items: center;
  transition: all ease-in-out 150ms;
  padding: 50px;
  cursor: pointer;
  z-index: 9;
  &:hover {
    opacity: 1;
  }
}
.drop-down-list {
  margin-top: 10px;
  top: 50px;
  filter: drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.04))
    drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.04))
    drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.04));
  border: solid thin #ededed;
  width: 120px;
  border-radius: 8px;
  display: none;
  top: 36px;
  background-color: #ffffff;
  border-radius: 4px 4px 4px 4px;
  text-align: left;
  cursor: pointer;
  border: 1px solid #bdbdbd;
  color: #3f3f3f;
  /*&:before {
    content: "";
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid white;
    top: -9px;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0px auto;
  }*/
  li {
    border: none !important;
    color: #3f3f3f;
    text-align: center;
    margin: 12px 0px;
    padding: 0px;
    font-size: 12px;
    font-family: "open sans";

    &.disabled {
      opacity: 0.5;
    }
  }
}
.buttons-container {
  top: 0;
  right: 0;
  z-index: 1;
}
  .download-menu {
    width: 260px !important;
    height: 185px !important;
    padding: 15px;

    .row-box {
      background: #D9D9D9;
      padding: 10px;
      border: 2px solid #D9D9D9;
    }

    .download-title {
      padding-bottom: 10px;
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #303336;
    }
  }
.mp4-title{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #444444;
}
.video-quality{
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  color: #6B6B6B;
}
  .download-btn{
    background: #D9D9D9;
    padding: 10px;
    border: none;
    outline: none;
    border-radius: 4px;
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #444444;
  }
  .active-btn{
    border: 2px solid #3BB0FA !important;
  }

  .disable-btn{
    opacity: 0.5;
    pointer-events: none;
    cursor: default;
  }
.svg-img-shapes{
  svg {
    width: auto !important;
    height: auto !important;
  }
}
/*.show-player{
  opacity: 1 !important;
}*/

.page {
  position: absolute;
  // left: -370px;
  //   bottom: -380px;
}

.preview-audio{
  width: 0;
  height: 0;
}
</style>
